import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/home";
import Contribute from "../pages/contribute";
import Register from "../pages/register";
import VerifyEmail from "../pages/verify-email";
import Profile from "../pages/profile";
import Dashboard from "../pages/dashboard";
import Notifications from "../pages/notifications";
import ProtectedRoute from "./ProtectedRoute";
import Layout from "@/common/Layout";
import ContributionDetails from "@/pages/contributionDetails";
import NavigationBreakdown from "@/pages/navigationBreakdown";
import NavigationDetail from "@/pages/navigationDetail";
import ForgotPassword from "../pages/forgotPassword";
import ResetPassword from "../pages/resetPassword";

const AllRoutes = () => {
  return (
    <Routes>
      {/* Public */}
      <Route index element={<Register />} />

      <Route path="verify-email" element={<VerifyEmail />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route path="reset-password" element={<ResetPassword />} />

      {/* Protected */}
      <Route element={<ProtectedRoute element={<Layout />} />}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="explore" element={<Home />} />
        <Route path="dashboard/:tab?" element={<Dashboard />} />
        <Route
          path="contribution/:action/:contribution_id?"
          element={<Contribute />}
        />
        <Route
          path="contribution/view/:contribution_id"
          element={<ContributionDetails />}
        />
        <Route path="profile/:tab?" element={<Profile />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="navigation/:place_id" element={<NavigationBreakdown />} />
        <Route path="navigation/:place_id/detail" element={<NavigationDetail />} />
      </Route>
    </Routes>
  );
};

export default AllRoutes;
